import React from 'react';
import { Card } from 'react-bootstrap';
import Select from 'react-select';
import { useTranslation } from 'react-i18next';
import CustomDatePicker from '../../../../../Components/Utility/DatePicker/DatePicker';
import { customStylesForTesting, currencyCodes } from '../../../../../Components/helper';
import { usePOrderDetailState } from '../PODetailProvider';

function OrderDetailTable() {
  const { poDetailstate, setPoDetailState, UnitOfMeasure, disablePoCondition } = usePOrderDetailState();
  const { rowsData } = poDetailstate;

  const addTableRows = () => {
    const lastRow = rowsData[rowsData.length - 1];
    const newRow = { ...lastRow };
    newRow.id = new Date().getTime();

    setPoDetailState((prev) => ({
      ...prev,
      rowsData: [...rowsData, newRow],
    }));
  };

  const deleteTableRows = (index) => {
    const rows = [...rowsData];
    rows.splice(index, 1);
    setPoDetailState((prev) => ({
      ...prev,
      rowsData: rows,
    }));
  };

  const handleChange = (index, evnt) => {
    const { name, value } = evnt.target;
    const rowsInput = [...rowsData];
    rowsInput[index][name] = value;
    rowsInput[index].hasError = false;

    setPoDetailState((prev) => ({
      ...prev,
      rowsData: rowsInput,
    }));
  };

  const handleSelected = (index, selected, name) => {
    const rowsInput = [...rowsData];
    rowsInput[index][name] = selected;
    rowsInput[index].hasError = false;
    setPoDetailState((prev) => ({
      ...prev,
      rowsData: rowsInput,
    }));
  };

  const calculateQuantitySum = () => {
    let sum = 0;
    rowsData.forEach((data) => {
      sum += parseFloat(data?.quantity) || 0;
    });
    return sum;
  };

  const handleSelectDateChange = (value) => {
    setPoDetailState((prevState) => ({
      ...prevState,
      shipmentDate: value,
    }));
  };
  const handlehandOverDate = (value) => {
    setPoDetailState((prevState) => ({
      ...prevState,
      handOverDate: value,
    }));
  };

  const calculatePricePerQuantity = (data) => {
    let totalPrice = 0;
    if (parseFloat(data?.quantity) > 0 && parseFloat(data?.price) > 0 && (data?.per > 0 || !data.per)) {
      totalPrice = (parseFloat(data?.quantity || 0) * parseFloat(data?.price || 0)) / (data?.per || 1);
    }
    return totalPrice;
  };

  const calculateTotalPrice = () => {
    let totalPrice = 0;
    rowsData.forEach((data) => {
      const pricePerQuantity = calculatePricePerQuantity(data);
      totalPrice += parseFloat(pricePerQuantity) || 0;
    });
    return totalPrice;
  };

  const handleKeyDown = (evnt) => {
    if (evnt.key === '-') {
      evnt.preventDefault();
    }
  };
  const handleKeyDownForQuantity = (evnt) => {
    if (evnt.key === '-' || evnt.key === '.') {
      evnt.preventDefault();
    }
  };
  const { t } = useTranslation('common');

  return (
    <Card className="listing-card">
      <Card.Header className="px-2 py-2 bgcolor-dark d-flex">
        <strong>{t('PURCHASE_ORDER_LIST.PURCHASE_ORDER_DETAILS.ALL_RENDER_TABLE.RENDER_ORDER_DETAIL.TITLE')}</strong>
        <div className="btn btn-border ml-auto py-0 px-1">
          <div className="input-button-container bg-white">
            <CustomDatePicker
              dateFormat="dd/MM/yyyy"
              name="handOverDate"
              popperPlace="top-end"
              placeholder={t('PURCHASE_ORDER_LIST.PURCHASE_ORDER_DETAILS.ALL_RENDER_TABLE.RENDER_ORDER_DETAIL.HANDOVER_DATE_PLACEHOLDER')}
              onChange={(date) => handlehandOverDate(date)}
              disable={disablePoCondition}
              valueProp={poDetailstate?.handOverDate ? new Date(poDetailstate?.handOverDate) : null}
            />
          </div>
        </div>
        <div className="btn btn-border  py-0 px-1">
          <div className="input-button-container bg-white">
            <CustomDatePicker
              dateFormat="dd/MM/yyyy"
              name="shipmentDate"
              popperPlace="top-end"
              placeholder={t('PURCHASE_ORDER_LIST.PURCHASE_ORDER_DETAILS.ALL_RENDER_TABLE.RENDER_ORDER_DETAIL.SHIPMENT_DATE_PLACEHOLDER')}
              onChange={(date) => handleSelectDateChange(date)}
              disable={disablePoCondition}
              valueProp={poDetailstate?.shipmentDate ? new Date(poDetailstate?.shipmentDate) : null}
            />
          </div>
        </div>
      </Card.Header>

      <Card.Body>
        <div className="table-responsive mb-2">
          <table className="table custom-table layout-fixed mb-0">
            <thead>
              <tr>
                <th className="w-120px">{t('PURCHASE_ORDER_LIST.PURCHASE_ORDER_DETAILS.ALL_RENDER_TABLE.RENDER_ORDER_DETAIL.REFERENCE')}</th>
                <th className="w-120px">{t('PURCHASE_ORDER_LIST.PURCHASE_ORDER_DETAILS.ALL_RENDER_TABLE.RENDER_ORDER_DETAIL.DESCRIPTION')}</th>
                <th className="w-120px">{t('PURCHASE_ORDER_LIST.PURCHASE_ORDER_DETAILS.ALL_RENDER_TABLE.RENDER_ORDER_DETAIL.COLOUR')}</th>
                <th className="w-170px">{t('PURCHASE_ORDER_LIST.PURCHASE_ORDER_DETAILS.ALL_RENDER_TABLE.RENDER_ORDER_DETAIL.SIZE')}</th>
                <th className="w-170px">{t('PURCHASE_ORDER_LIST.PURCHASE_ORDER_DETAILS.ALL_RENDER_TABLE.RENDER_ORDER_DETAIL.QUANTITY')}</th>
                <th className="w-170px">{t('PURCHASE_ORDER_LIST.PURCHASE_ORDER_DETAILS.ALL_RENDER_TABLE.RENDER_ORDER_DETAIL.PRICE')}</th>
                <th className="w-100px">{t('PURCHASE_ORDER_LIST.PURCHASE_ORDER_DETAILS.ALL_RENDER_TABLE.RENDER_ORDER_DETAIL.PER')}</th>
                <th className="w-100px">{t('PURCHASE_ORDER_LIST.PURCHASE_ORDER_DETAILS.ALL_RENDER_TABLE.RENDER_ORDER_DETAIL.TOTAL')}</th>
                <th className="w-100px">{t('PURCHASE_ORDER_LIST.PURCHASE_ORDER_DETAILS.ALL_RENDER_TABLE.RENDER_ORDER_DETAIL.ACTION')}</th>
              </tr>
            </thead>
            <tbody>
              {rowsData.map((data, index) => {
                const { reference, description, quantity, colorway, price, per, size, sizeType, quantityType, currency } = data;
                const currencyOption = currencyCodes?.map((code) => {
                  return {
                    value: code,
                    label: code,
                  };
                });

                return (
                  <tr key={data?.id}>
                    <td>
                      <input
                        type="text"
                        value={reference}
                        onChange={(evnt) => handleChange(index, evnt)}
                        name="reference"
                        className="form-control text-bordered"
                        disabled={disablePoCondition}
                      />
                      {data?.hasError && !reference && (
                        <small className="error-message">
                          {t('PURCHASE_ORDER_LIST.PURCHASE_ORDER_DETAILS.ALL_RENDER_TABLE.RENDER_ORDER_DETAIL.REFERENCE_REQUIRED')}
                        </small>
                      )}
                    </td>
                    <td>
                      <input
                        type="text"
                        value={description}
                        onChange={(evnt) => handleChange(index, evnt)}
                        name="description"
                        className="form-control text-bordered"
                        disabled={disablePoCondition}
                      />{' '}
                    </td>
                    <td>
                      <input
                        type="text"
                        value={colorway}
                        onChange={(evnt) => handleChange(index, evnt)}
                        name="colorway"
                        className="form-control text-bordered"
                        disabled={disablePoCondition}
                      />{' '}
                    </td>
                    <td>
                      <div className="d-flex align-items-end">
                        <input
                          type="number"
                          value={size}
                          onChange={(evnt) => handleChange(index, evnt)}
                          name="size"
                          className="form-control text-bordered"
                          disabled={disablePoCondition}
                          onKeyDown={handleKeyDown}
                        />{' '}
                        <div className="w-80px ml-1">
                          <Select
                            className="text-dark"
                            styles={customStylesForTesting}
                            placeholder="UoM"
                            menuPosition="fixed"
                            name="sizeType"
                            type="text"
                            isDisabled={disablePoCondition}
                            value={UnitOfMeasure?.find((unit) => unit?.name === sizeType)}
                            options={UnitOfMeasure}
                            getOptionLabel={(option) => `${option.name}`}
                            getOptionValue={(option) => `${option._id}`}
                            onChange={(selected) => handleSelected(index, selected?.name, 'sizeType')}
                          />
                        </div>
                      </div>
                    </td>
                    <td>
                      <div className="d-flex align-items-end">
                        <input
                          type="number"
                          value={quantity}
                          onChange={(evnt) => handleChange(index, evnt)}
                          name="quantity"
                          className="form-control text-bordered"
                          disabled={disablePoCondition}
                          onKeyDown={handleKeyDownForQuantity}
                        />{' '}
                        <div className="w-80px ml-1">
                          <Select
                            className="text-dark"
                            styles={customStylesForTesting}
                            placeholder="UoM"
                            menuPosition="fixed"
                            name="quantityType"
                            isDisabled={disablePoCondition}
                            options={UnitOfMeasure}
                            getOptionLabel={(option) => `${option.name}`}
                            getOptionValue={(option) => `${option._id}`}
                            onChange={(selected) => handleSelected(index, selected?.name, 'quantityType')}
                            value={UnitOfMeasure?.find((unit) => unit?.name === quantityType)}
                          />
                        </div>
                      </div>
                      {data?.hasError && !quantity && (
                        <small className="error-message">
                          {' '}
                          {t('PURCHASE_ORDER_LIST.PURCHASE_ORDER_DETAILS.ALL_RENDER_TABLE.RENDER_ORDER_DETAIL.QUANTITY_REQUIRED')}
                        </small>
                      )}
                      {data?.hasError && !quantityType && (
                        <small className="error-message">
                          {' '}
                          {t('PURCHASE_ORDER_LIST.PURCHASE_ORDER_DETAILS.ALL_RENDER_TABLE.RENDER_ORDER_DETAIL.QUANTITY_REQUIRED_TYPE')}
                        </small>
                      )}
                    </td>{' '}
                    <td>
                      <div className="d-flex align-items-end">
                        <input
                          type="number"
                          value={price}
                          onChange={(evnt) => handleChange(index, evnt)}
                          name="price"
                          className="form-control text-bordered"
                          disabled={disablePoCondition}
                          onKeyDown={handleKeyDown}
                        />{' '}
                        <div className="w-80px ml-1">
                          <Select
                            className="text-dark"
                            styles={customStylesForTesting}
                            placeholder="UoM"
                            menuPosition="fixed"
                            name="currency"
                            isDisabled={disablePoCondition}
                            options={currencyOption}
                            getOptionLabel={({ label }) => `${label}`}
                            getOptionValue={({ label }) => `${label}`}
                            onChange={(selected) => handleSelected(index, selected?.value, 'currency')}
                            value={currencyOption?.find((unit) => unit?.value === currency)}
                          />
                        </div>
                      </div>
                      {data?.hasError && !price && (
                        <small className="error-message">
                          {' '}
                          {t('PURCHASE_ORDER_LIST.PURCHASE_ORDER_DETAILS.ALL_RENDER_TABLE.RENDER_ORDER_DETAIL.PRICE_REQUIRED')}
                        </small>
                      )}
                      {data?.hasError && !currency && (
                        <small className="error-message">
                          {' '}
                          {t('PURCHASE_ORDER_LIST.PURCHASE_ORDER_DETAILS.ALL_RENDER_TABLE.RENDER_ORDER_DETAIL.PRICE_TYPE_REQUIRED')}
                        </small>
                      )}
                    </td>
                    <td>
                      <input
                        type="number"
                        value={per}
                        onChange={(evnt) => handleChange(index, evnt)}
                        name="per"
                        className="form-control text-bordered"
                        disabled={disablePoCondition}
                        onKeyDown={handleKeyDown}
                      />{' '}
                      {data?.hasError && !per && (
                        <small className="error-message">
                          {' '}
                          {t('PURCHASE_ORDER_LIST.PURCHASE_ORDER_DETAILS.ALL_RENDER_TABLE.RENDER_ORDER_DETAIL.PER_REQUIRED')}
                        </small>
                      )}
                    </td>{' '}
                    <td>
                      <input type="text" value={calculatePricePerQuantity(data)} className="form-control text-bordered" disabled={disablePoCondition} />{' '}
                    </td>
                    <td>
                      <button onClick={addTableRows} type="button" disabled={disablePoCondition} className="btn btn-action-icon m-0">
                        <span className="icon-add" />
                      </button>
                      {rowsData.length > 1 && (
                        <button onClick={() => deleteTableRows(index)} type="button" disabled={disablePoCondition} className="btn btn-action-icon m-0">
                          <span className="icon-delete" />
                        </button>
                      )}
                    </td>
                  </tr>
                );
              })}
              <tr>
                <td />
                <td />
                <td />
                <td />
                <td>{calculateQuantitySum()}</td>
                <td />

                <td />
                <td>
                  <b> {calculateTotalPrice()}</b>
                </td>
                <td />
              </tr>
            </tbody>
          </table>
        </div>
      </Card.Body>
    </Card>
  );
}
export default OrderDetailTable;
